import*as t from"react";import{ThemeContext as e}from"@emotion/react";function o(o=null){const r=t.useContext(e);return r&&(n=r,0!==Object.keys(n).length)?r:o;var n}export{o as u};
